module.exports = __webpack_public_path__ + "static/media/Laugo_16.b1145c69.jpg";